import React, { useState } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { artistNameInvalidCheck, isrcInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { Recording } from '@Entities/matching/recording-group-details'
import RecordingCardDetails from '@Components/Cards/WorkDetailCards/RecordingCard/RecordingCardDetails'
import RecordingCardHeader from '@Components/Cards/WorkDetailCards/RecordingCard/RecordingCardHeader'
import { RecordingModel } from '@Entities/work/recording-model'

interface RecordingCardProps {
    data?: RecordingModel | Recording | null
    removeFunction?(removeRecording: RecordingModel | Recording): void
    editFunction?(editingRecording: RecordingModel | Recording): void
}

const RecordingCard = (props: RecordingCardProps) => {
    const { data, removeFunction, editFunction } = props
    const [detailsIsOpen, setDetailsIsOpen] = useState<boolean>(false)

    const title = data && 'title' in data ? data.title : data?.recordingTitle
    const artistName = data && 'artistName' in data ? data.artistName : data?.recordingDisplayArtistName
    const isrc = data?.isrc
    const duration = data?.duration
    const label = data?.label
    const releaseDate = data?.releaseDate

    return (
        <div className="recording-card">
            <RecordingCardHeader
                data={data}
                removeFunction={removeFunction}
                editFunction={editFunction}
                title={title}
            />
            <div className="content">
                <p className="small">
                    <span className={`${isrcInvalidCheck(isrc) ? 'red-text bold' : ''}`}>ISRC:&nbsp;</span>
                    <strong>{isrc || ''}</strong>
                </p>
                <p className={`small ${artistNameInvalidCheck(artistName) ? 'red-text bold' : ''}`}>Artist:</p>
                <div className="row-container">
                    <p className="bold">{artistName ? stringEscapeNewlines(artistName) : ''}</p>
                    <p onClick={() => setDetailsIsOpen(!detailsIsOpen)} className="details small bold">
                        More Info {detailsIsOpen ? '-' : '+'}
                    </p>
                </div>
                {detailsIsOpen && <RecordingCardDetails duration={duration} label={label} releaseDate={releaseDate} />}
            </div>
        </div>
    )
}

export default observer(RecordingCard)
